import { required, useTranslate } from "ra-core";
import { useWatch } from "react-hook-form";
import { DateInput } from "@/components/admin/date-input";
import { RadioButtonGroupInput } from "@/components/admin/radio-button-group-input";
import { TextInput } from "@/components/admin/text-input";
import type { ContactRole } from "../types";

export const contactRoles: { id: ContactRole }[] = [
  { id: "guardian" },
  { id: "player" },
];

/** Guardian (parent who pays) or player (the child). */
export const ContactRoleInput = () => {
  const translate = useTranslate();
  return (
    <RadioButtonGroupInput
      source="role"
      row
      helperText={false}
      choices={contactRoles}
      optionText={(choice: { id: ContactRole }) =>
        translate(`resources.contacts.roles.${choice.id}`)
      }
      translateChoice={false}
      defaultValue="guardian"
      validate={required()}
    />
  );
};

/** Details a coach needs about a child. Only shown for players. */
export const PlayerInputs = () => {
  const translate = useTranslate();
  const role = useWatch({ name: "role" }) as ContactRole | undefined;
  if (role !== "player") return null;
  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-lg font-semibold">
        {translate("resources.contacts.field_categories.player")}
      </h6>
      <DateInput source="date_of_birth" helperText={false} />
      <TextInput
        source="medical_notes"
        multiline
        helperText={translate("resources.contacts.helpers.medical_notes")}
      />
      <TextInput
        source="coach_notes"
        multiline
        helperText={translate("resources.contacts.helpers.coach_notes")}
      />
    </div>
  );
};
